import { useQuery } from '@tanstack/react-query';

import { financeExportReportApi } from '@entities/financeExportReport';

export const useGetFinanceExportReports = () =>
    useQuery(financeExportReportApi.getReportsQueryOptions());
